import Booking from '@solvhealth/types/interfaces/Booking';

const emptyValidation = {
  isAuxiliary: false,
  isPrimary: false,
  isFamilyBooking: false,
  familyId: '',
};

export function validateFamilyBooking(booking: Booking): {
  isAuxiliary: boolean;
  isPrimary: boolean;
  isFamilyBooking: boolean;
  familyId: string;
} {
  if (!booking) {
    return emptyValidation;
  }

  const bookingFamilyId = booking.booking_family_id || booking.bookingFamilyId;
  if (!bookingFamilyId) {
    return emptyValidation;
  }

  const type = booking.booking_family_member_type || booking.bookingFamilyMemberType;

  return {
    isAuxiliary: type === 'auxiliary',
    isPrimary: type === 'primary',
    familyId: bookingFamilyId,
    isFamilyBooking: true,
  };
}
